import {h, Fragment} from "preact"
import { useMemo } from "preact/hooks";

export default function Reviews({ productId, value }) {
  	if(!value) return;
  	const rounded = useMemo(() => Math.round(value * 2) / 2, []);
  
  	return (
		<div class="ns-reviews ns-flex ns-flex-row ns-items-center ns-justify-start" data-value={value} data-rounded={rounded}>
			{[1, 2, 3, 4, 5].map(i => (
				rounded >= i ? (
					<div key={i} class="ns-star ns-flex">
						<svg viewBox="0 0 18 18" tabindex="0" xmlns="http://www.w3.org/2000/svg" role="img" width="15" height="15" aria-label={`Star ${i} out of 5`}>
							<path aria-hidden="true" style="pointer-events: none;" d="M9 14.118L14.562 17.475L13.086 11.148L18 6.891L11.529 6.342L9 0.375L6.471 6.342L0 6.891L4.914 11.148L3.438 17.475L9 14.118Z" stroke="#000" fill="#000"></path>
						</svg>
					</div>
				) : rounded + 0.5 === i ? (
					<div key={i} class="ns-star ns-flex">
						<svg viewBox="0 0 18 18" tabindex="0" xmlns="http://www.w3.org/2000/svg" role="img" width="15" height="15" aria-label={`Star ${i} out of 5`}>
							<defs>
								<linearGradient aria-hidden="true" id={`${productId}-${i}`}>
									<stop offset="51%" stop-color="#000"></stop>
									<stop stop-opacity="1" offset="50%" stop-color="#FFFFFF"></stop>
								</linearGradient>
							</defs>
							<path aria-hidden="true" style="pointer-events: none;" d="M9 14.118L14.562 17.475L13.086 11.148L18 6.891L11.529 6.342L9 0.375L6.471 6.342L0 6.891L4.914 11.148L3.438 17.475L9 14.118Z" stroke="#000" fill={`url('#${productId}-${i}')`}></path>
						</svg>
					</div>
				) : (
					<div key={i} class="ns-star ns-flex">
						<svg viewBox="0 0 18 18" tabindex="0" xmlns="http://www.w3.org/2000/svg" role="img" width="15" height="15" aria-label={`Star ${i} out of 5`}>
							<path aria-hidden="true" style="pointer-events: none;" d="M9 14.118L14.562 17.475L13.086 11.148L18 6.891L11.529 6.342L9 0.375L6.471 6.342L0 6.891L4.914 11.148L3.438 17.475L9 14.118Z" stroke="#000" fill="#FFF"></path>
						</svg>
					</div>
				)
			))}
		</div>
  	);
}

/* previously: */

/* [Products.jsx]
	useEffect(() => {
		if(typeof window.yotpoWidgetsContainer?.initWidgets === 'function') {
			window.yotpoWidgetsContainer.initWidgets();
		}
	}, [ products.hits ])
*/

/* [Product.jsx]
	import { themes } from '../config'

	<div 
		class="yotpo bottomLine yotpo-small" 
		data-product-id={activeSwatch.productId}
		data-yotpo-instance-id={themes.yotpoInstanceId}
	/>
*/